import { instance } from './axiosConfig'

export default {
  // Retrive all configuration of the gorup
  async getConfigurations(groupId) {
    const url = `/groups/${groupId}/configurations/videos`

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
  },

  // Create new group configuration
  async createConfiguration(groupId, body) {
    const url = `/groups/${groupId}/configurations/videos`

    try {
      return await instance.post(url, body)
    } catch (err) {
      return err
    }
  },

  // Modify existing media
  // Type is one of this value : introduction, conclusion, audio
  async modifyMedia(groupId, idConfigurationVideo, mediaType, presignedUrl) {
    const url = `/groups/${groupId}/configurations/videos/${idConfigurationVideo}/${mediaType}`

    try {
      return await instance.put(url, { url: presignedUrl })
    } catch (err) {
      return err
    }
  },

  // Delete exisiting media
  // Type is one of this value : introduction, conclusion, audio
  async deleteMedia(groupId, idConfigurationVideo, type) {
    const url = `/groups/${groupId}/configurations/videos/${idConfigurationVideo}/${type}`

    try {
      return await instance.delete(url)
    } catch (err) {
      return err
    }
  }
}
